import React from 'react'
import GetTutorForm from '../components/getTutorForm'

function GetTutor() {
  return (
    <div>
      <GetTutorForm/>
    </div>
  )
}

export default GetTutor